/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ActiveCompetitorsResponse } from '../models/ActiveCompetitorsResponse';
import type { AddActiveCompetitorRequest } from '../models/AddActiveCompetitorRequest';
import type { AdGenerationCreditsResponse } from '../models/AdGenerationCreditsResponse';
import type { AdGenerationJobResponse } from '../models/AdGenerationJobResponse';
import type { AdsetCreated } from '../models/AdsetCreated';
import type { AdStatusUpdated } from '../models/AdStatusUpdated';
import type { AuthUrlResponse } from '../models/AuthUrlResponse';
import type { BatchAdRequest } from '../models/BatchAdRequest';
import type { BatchAdResponse } from '../models/BatchAdResponse';
import type { Body_ad_management_create_product } from '../models/Body_ad_management_create_product';
import type { Body_ad_management_upload_reference } from '../models/Body_ad_management_upload_reference';
import type { BrandLookupRequest } from '../models/BrandLookupRequest';
import type { BrandLookupResponse } from '../models/BrandLookupResponse';
import type { BrandProduct } from '../models/BrandProduct';
import type { CampaignCreated } from '../models/CampaignCreated';
import type { ChatEditImageRequest } from '../models/ChatEditImageRequest';
import type { ChatEditImageResponse } from '../models/ChatEditImageResponse';
import type { CompetitorResearchState } from '../models/CompetitorResearchState';
import type { CompetitorView } from '../models/CompetitorView';
import type { CopyAdRequest } from '../models/CopyAdRequest';
import type { CopyAdResponse } from '../models/CopyAdResponse';
import type { CreateAdsetRequest } from '../models/CreateAdsetRequest';
import type { CreateCampaignRequest } from '../models/CreateCampaignRequest';
import type { DisconnectRequest } from '../models/DisconnectRequest';
import type { GenerateAdsRequest } from '../models/GenerateAdsRequest';
import type { MetaAdAccount } from '../models/MetaAdAccount';
import type { MetaAdLogRead } from '../models/MetaAdLogRead';
import type { MetaAdPage } from '../models/MetaAdPage';
import type { MetaAdset } from '../models/MetaAdset';
import type { MetaCampaign } from '../models/MetaCampaign';
import type { MetaConnectionRead } from '../models/MetaConnectionRead';
import type { MetaInstagramAccount } from '../models/MetaInstagramAccount';
import type { MetaPage } from '../models/MetaPage';
import type { PexelsImportRequest } from '../models/PexelsImportRequest';
import type { PexelsSearchResponse } from '../models/PexelsSearchResponse';
import type { ProductsExtractResponse } from '../models/ProductsExtractResponse';
import type { ProductsListResponse } from '../models/ProductsListResponse';
import type { RecentAdset } from '../models/RecentAdset';
import type { RegenerateFieldRequest } from '../models/RegenerateFieldRequest';
import type { RegenerateFieldResponse } from '../models/RegenerateFieldResponse';
import type { RemoveReferenceImageRequest } from '../models/RemoveReferenceImageRequest';
import type { RequestCreditsRequest } from '../models/RequestCreditsRequest';
import type { ScrapeMoreResponse } from '../models/ScrapeMoreResponse';
import type { SelectDefaultsRequest } from '../models/SelectDefaultsRequest';
import type { StartGenerationResponse } from '../models/StartGenerationResponse';
import type { SwitchConnectionRequest } from '../models/SwitchConnectionRequest';
import type { ToggleFavouriteResponse } from '../models/ToggleFavouriteResponse';
import type { TriggerAdGenerationResponse } from '../models/TriggerAdGenerationResponse';
import type { UpdateAdStatusRequest } from '../models/UpdateAdStatusRequest';
import type { UploadReferenceImageResponse } from '../models/UploadReferenceImageResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdManagementService {
    /**
     * Start Ad Generation
     * Scrape brand website, generate brand presets, and return reference images.
     * @param brandId
     * @param websiteUrl
     * @returns StartGenerationResponse Successful Response
     * @throws ApiError
     */
    public static startAdGeneration(
        brandId: number,
        websiteUrl?: (string | null),
    ): CancelablePromise<StartGenerationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/start',
            query: {
                'brand_id': brandId,
                'website_url': websiteUrl,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Ad Generation Doc
     * The brand's ad-generation job with its ads newest-first, or null if none exists.
     * @param brandId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAdGenerationDoc(
        brandId: number,
    ): CancelablePromise<(AdGenerationJobResponse | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/generate/list',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Trigger Ad Generation
     * Generate ads for the brand, one credit per version.
     *
     * Requires a scraped website (start generation first). Answers with
     * `credits_exhausted` rather than an error when the allowance is short.
     * @param brandId
     * @param requestBody
     * @returns TriggerAdGenerationResponse Successful Response
     * @throws ApiError
     */
    public static triggerAdGeneration(
        brandId: number,
        requestBody: GenerateAdsRequest,
    ): CancelablePromise<TriggerAdGenerationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Credits
     * Credits consumed, allowed and remaining for ad generation.
     * @param brandId
     * @returns AdGenerationCreditsResponse Successful Response
     * @throws ApiError
     */
    public static credits(
        brandId: number,
    ): CancelablePromise<AdGenerationCreditsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/generate/credits',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Reference
     * Upload a single reference image to GCS and record it for the brand.
     * @param brandId
     * @param formData
     * @returns UploadReferenceImageResponse Successful Response
     * @throws ApiError
     */
    public static uploadReference(
        brandId: number,
        formData: Body_ad_management_upload_reference,
    ): CancelablePromise<UploadReferenceImageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/reference-images/upload',
            query: {
                'brand_id': brandId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Scrape More Images
     * Re-scrape brand website for new images, dedup by original_url.
     * @param brandId
     * @param websiteUrl
     * @returns ScrapeMoreResponse Successful Response
     * @throws ApiError
     */
    public static scrapeMoreImages(
        brandId: number,
        websiteUrl?: (string | null),
    ): CancelablePromise<ScrapeMoreResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/reference-images/scrape',
            query: {
                'brand_id': brandId,
                'website_url': websiteUrl,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Reference
     * Remove a reference image from the list.
     * @param brandId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static removeReference(
        brandId: number,
        requestBody: RemoveReferenceImageRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ad-management/generate/reference-images',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pexels Search
     * Search Pexels for royalty-free stock images.
     * @param query
     * @param brandId
     * @returns PexelsSearchResponse Successful Response
     * @throws ApiError
     */
    public static pexelsSearch(
        query: string,
        brandId: number,
    ): CancelablePromise<PexelsSearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/generate/pexels-search',
            query: {
                'query': query,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Pexels Import
     * Download a Pexels image to GCS and add to reference images.
     * @param brandId
     * @param requestBody
     * @returns UploadReferenceImageResponse Successful Response
     * @throws ApiError
     */
    public static pexelsImport(
        brandId: number,
        requestBody: PexelsImportRequest,
    ): CancelablePromise<UploadReferenceImageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/pexels-import',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Chat Edit Image
     * Edit a generated ad image via chat instruction. Consumes 1 credit.
     * @param brandId
     * @param requestBody
     * @returns ChatEditImageResponse Successful Response
     * @throws ApiError
     */
    public static chatEditImage(
        brandId: number,
        requestBody: ChatEditImageRequest,
    ): CancelablePromise<ChatEditImageResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/chat-edit',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Regenerate Field
     * Regenerate a single ad copy field (primary_text, headline, or description).
     * @param requestBody
     * @returns RegenerateFieldResponse Successful Response
     * @throws ApiError
     */
    public static regenerateField(
        requestBody: RegenerateFieldRequest,
    ): CancelablePromise<RegenerateFieldResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/regenerate-field',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Request Credits
     * Send a Slack notification requesting more ad generation credits.
     * @param brandId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static requestCredits(
        brandId: number,
        requestBody: RequestCreditsRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/generate/request-credits',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Ad Image
     * Point a generated ad at a different image it already produced.
     * @param adIndex
     * @param brandId
     * @param imageUrl
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateAdImage(
        adIndex: number,
        brandId: number,
        imageUrl: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/ad-management/generate/ads/{ad_index}/image',
            path: {
                'ad_index': adIndex,
            },
            query: {
                'brand_id': brandId,
                'image_url': imageUrl,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get State
     * Competitor research state, starting discovery on the first call.
     *
     * Poll this until `discovered` is true. `website_url` sets the brand's site if
     * it has none, and `retry` runs discovery again from scratch.
     * @param brandId
     * @param retry
     * @param websiteUrl
     * @returns CompetitorResearchState Successful Response
     * @throws ApiError
     */
    public static getState(
        brandId: number,
        retry: boolean = false,
        websiteUrl?: (string | null),
    ): CancelablePromise<CompetitorResearchState> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/competitor-research/',
            query: {
                'brand_id': brandId,
                'retry': retry,
                'website_url': websiteUrl,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Active Competitors
     * The competitors this brand tracks, each with its scraped ads.
     * @param brandId
     * @returns ActiveCompetitorsResponse Successful Response
     * @throws ApiError
     */
    public static getActiveCompetitors(
        brandId: number,
    ): CancelablePromise<ActiveCompetitorsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/competitor-research/active',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Active Competitor
     * Track a competitor page and scrape its active ads.
     *
     * 400s once the brand is at its tracked-competitor limit.
     * @param brandId
     * @param requestBody
     * @returns CompetitorView Successful Response
     * @throws ApiError
     */
    public static addActiveCompetitor(
        brandId: number,
        requestBody: AddActiveCompetitorRequest,
    ): CancelablePromise<CompetitorView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/active/add',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Toggle Active Competitor
     * Show or hide an already-scraped competitor, keeping its scraped ads.
     * @param brandId
     * @param pageId
     * @param active
     * @returns any Successful Response
     * @throws ApiError
     */
    public static toggleActiveCompetitor(
        brandId: number,
        pageId: string,
        active: boolean,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/active/toggle',
            query: {
                'brand_id': brandId,
                'page_id': pageId,
                'active': active,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Toggle Favourite Ad
     * Save or unsave a competitor ad, returning its state after the toggle.
     * @param brandId
     * @param adArchiveId
     * @returns ToggleFavouriteResponse Successful Response
     * @throws ApiError
     */
    public static toggleFavouriteAd(
        brandId: number,
        adArchiveId: string,
    ): CancelablePromise<ToggleFavouriteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/favourites/toggle',
            query: {
                'brand_id': brandId,
                'ad_archive_id': adArchiveId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Scrape Inactive
     * Scrape a competitor's retired ads.
     *
     * Separate from tracking because it only runs when the inactive filter is
     * turned on, and it is the slower of the two scrapes.
     * @param pageId
     * @param brandId
     * @returns CompetitorView Successful Response
     * @throws ApiError
     */
    public static scrapeInactive(
        pageId: string,
        brandId: number,
    ): CancelablePromise<CompetitorView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/scrape-inactive',
            query: {
                'page_id': pageId,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Competitor
     * Re-scrape one competitor's active and inactive ads, ignoring the cache.
     * @param pageId
     * @param brandId
     * @returns CompetitorView Successful Response
     * @throws ApiError
     */
    public static refreshCompetitor(
        pageId: string,
        brandId: number,
    ): CancelablePromise<CompetitorView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/refresh',
            query: {
                'page_id': pageId,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Lookup Brand
     * Search Facebook pages by name, for picking a competitor to track.
     *
     * Answers with an empty match list rather than an error when the search fails.
     * @param brandId
     * @param requestBody
     * @returns BrandLookupResponse Successful Response
     * @throws ApiError
     */
    public static lookupBrand(
        brandId: number,
        requestBody: BrandLookupRequest,
    ): CancelablePromise<BrandLookupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/lookup-brand',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Copy Ad
     * Clone Ad flow — same ideation as /generate, but every version is an edit
     * of the pinned reference ad with the user's product images as references.
     *
     * The client owns and sends the reference_image_url (competitor ad) and
     * product_image_urls directly; we don't re-hydrate them from storage here.
     * @param brandId
     * @param requestBody
     * @returns CopyAdResponse Successful Response
     * @throws ApiError
     */
    public static copyAd(
        brandId: number,
        requestBody: CopyAdRequest,
    ): CancelablePromise<CopyAdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/copy-ad',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Extract Products
     * Run extraction if the background task hasn't finished yet.
     * @param brandId
     * @returns ProductsExtractResponse Successful Response
     * @throws ApiError
     */
    public static extractProducts(
        brandId: number,
    ): CancelablePromise<ProductsExtractResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/products/extract',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Products
     * The brand's products, and whether extraction has run yet.
     * @param brandId
     * @returns ProductsListResponse Successful Response
     * @throws ApiError
     */
    public static listProducts(
        brandId: number,
    ): CancelablePromise<ProductsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/competitor-research/products',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Product
     * Manual Add Product flow: upload an image to GCS and append to products.
     * @param brandId
     * @param formData
     * @param label
     * @returns BrandProduct Successful Response
     * @throws ApiError
     */
    public static createProduct(
        brandId: number,
        formData: Body_ad_management_create_product,
        label?: (string | null),
    ): CancelablePromise<BrandProduct> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/competitor-research/products',
            query: {
                'brand_id': brandId,
                'label': label,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Product
     * Remove a manually-added or extracted product from the brand's product list.
     * @param productId
     * @param brandId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteProduct(
        productId: string,
        brandId: number,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/ad-management/competitor-research/products/{product_id}',
            path: {
                'product_id': productId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Auth Url
     * The Meta authorization URL to open, carrying a signed state token.
     * @param brandId
     * @returns AuthUrlResponse Successful Response
     * @throws ApiError
     */
    public static getAuthUrl(
        brandId: number,
    ): CancelablePromise<AuthUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/auth-url',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Oauth Callback
     * Where Meta sends the user back. Renders a page that closes itself.
     *
     * Unauthenticated by design — the caller is Meta, and the signed `state` is
     * what identifies the brand and the account that started the flow.
     * @param code
     * @param state
     * @param error
     * @returns string Successful Response
     * @throws ApiError
     */
    public static oauthCallback(
        code: string = '',
        state: string = '',
        error: string = '',
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/callback',
            query: {
                'code': code,
                'state': state,
                'error': error,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Connection
     * The brand's active Meta connection, or null if it has none.
     * @param brandId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getConnection(
        brandId: number,
    ): CancelablePromise<(MetaConnectionRead | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/connection',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Connections
     * Every Meta connection the brand has authorized, newest first.
     * @param brandId
     * @returns MetaConnectionRead Successful Response
     * @throws ApiError
     */
    public static getConnections(
        brandId: number,
    ): CancelablePromise<Array<MetaConnectionRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/connections',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Disconnect
     * Make a connection inactive. The token is kept so it can be switched back on.
     * @param requestBody
     * @returns MetaConnectionRead Successful Response
     * @throws ApiError
     */
    public static disconnect(
        requestBody: DisconnectRequest,
    ): CancelablePromise<MetaConnectionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/meta/disconnect',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Switch Connection
     * Make another authorized connection the active one for this brand.
     * @param requestBody
     * @returns MetaConnectionRead Successful Response
     * @throws ApiError
     */
    public static switchConnection(
        requestBody: SwitchConnectionRequest,
    ): CancelablePromise<MetaConnectionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/meta/switch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Select Defaults
     * Remember which ad account and page this brand works in.
     * @param requestBody
     * @returns MetaConnectionRead Successful Response
     * @throws ApiError
     */
    public static selectDefaults(
        requestBody: SelectDefaultsRequest,
    ): CancelablePromise<MetaConnectionRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/meta/select-defaults',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Ad Accounts
     * The ad accounts the connected Meta user can advertise from.
     * @param brandId
     * @returns MetaAdAccount Successful Response
     * @throws ApiError
     */
    public static getAdAccounts(
        brandId: number,
    ): CancelablePromise<Array<MetaAdAccount>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/ad-accounts',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Pages
     * The Facebook pages the connected user administers.
     * @param brandId
     * @returns MetaPage Successful Response
     * @throws ApiError
     */
    public static getPages(
        brandId: number,
    ): CancelablePromise<Array<MetaPage>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/pages',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Instagram Accounts
     * Instagram business accounts reachable through those pages.
     * @param brandId
     * @returns MetaInstagramAccount Successful Response
     * @throws ApiError
     */
    public static getInstagramAccounts(
        brandId: number,
    ): CancelablePromise<Array<MetaInstagramAccount>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/instagram-accounts',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Campaigns
     * Campaigns in one ad account, the selected one unless another is named.
     * @param brandId
     * @param adAccountId
     * @returns MetaCampaign Successful Response
     * @throws ApiError
     */
    public static getCampaigns(
        brandId: number,
        adAccountId?: (string | null),
    ): CancelablePromise<Array<MetaCampaign>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/campaigns',
            query: {
                'ad_account_id': adAccountId,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Adsets
     * Ad sets under one campaign.
     * @param campaignId
     * @param brandId
     * @returns MetaAdset Successful Response
     * @throws ApiError
     */
    public static getAdsets(
        campaignId: string,
        brandId: number,
    ): CancelablePromise<Array<MetaAdset>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/adsets',
            query: {
                'campaign_id': campaignId,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Search Locations
     * Meta's targeting geolocations matching a query — countries, regions, cities.
     * @param q
     * @param brandId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static searchLocations(
        q: string,
        brandId: number,
    ): CancelablePromise<Array<Record<string, any>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/locations',
            query: {
                'q': q,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Campaign
     * Create a campaign in the brand's selected ad account.
     * @param brandId
     * @param requestBody
     * @returns CampaignCreated Successful Response
     * @throws ApiError
     */
    public static createCampaign(
        brandId: number,
        requestBody: CreateCampaignRequest,
    ): CancelablePromise<CampaignCreated> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/meta/create/campaign',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Adset
     * Create an ad set under a campaign, with its budget, schedule and targeting.
     * @param brandId
     * @param requestBody
     * @returns AdsetCreated Successful Response
     * @throws ApiError
     */
    public static createAdset(
        brandId: number,
        requestBody: CreateAdsetRequest,
    ): CancelablePromise<AdsetCreated> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/meta/create/adset',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Ad Status
     * Pause or resume one live ad.
     * @param metaAdId
     * @param brandId
     * @param requestBody
     * @returns AdStatusUpdated Successful Response
     * @throws ApiError
     */
    public static updateAdStatus(
        metaAdId: string,
        brandId: number,
        requestBody: UpdateAdStatusRequest,
    ): CancelablePromise<AdStatusUpdated> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/ad-management/meta/ads/{meta_ad_id}/status',
            path: {
                'meta_ad_id': metaAdId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Batch Ad
     * Publish several ads into one ad set, reporting each one's outcome.
     *
     * Each ad names either an `ad_index` — a generated ad of this brand — or an
     * `image_url`. One ad failing does not stop the others; its `error` says why.
     * @param brandId
     * @param requestBody
     * @returns BatchAdResponse Successful Response
     * @throws ApiError
     */
    public static createBatchAd(
        brandId: number,
        requestBody: BatchAdRequest,
    ): CancelablePromise<BatchAdResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ad-management/meta/create/batch-ad',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Ads
     * One page of the account's ads with their insights, live from Meta.
     *
     * Narrowed by ad set when given, else by campaign, else the whole ad account.
     * Ads this service published carry their log; archived ones sort last. The
     * insights of logged ads are stored on the way past.
     * @param brandId
     * @param campaignId
     * @param adsetId
     * @param pageCursor
     * @param pageLimit
     * @returns MetaAdPage Successful Response
     * @throws ApiError
     */
    public static getAds(
        brandId: number,
        campaignId?: (string | null),
        adsetId?: (string | null),
        pageCursor?: (string | null),
        pageLimit: number = 10,
    ): CancelablePromise<MetaAdPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/ads',
            query: {
                'campaign_id': campaignId,
                'adset_id': adsetId,
                'page_cursor': pageCursor,
                'page_limit': pageLimit,
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Ad Detail
     * Everything Meta knows about one ad, insights included and stored if we published it.
     * @param metaAdId
     * @param brandId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getAdDetail(
        metaAdId: string,
        brandId: number,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/ad-detail/{meta_ad_id}',
            path: {
                'meta_ad_id': metaAdId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Recent Adsets
     * The ad sets this brand published to most recently in the selected ad account.
     * @param brandId
     * @returns RecentAdset Successful Response
     * @throws ApiError
     */
    public static getRecentAdsets(
        brandId: number,
    ): CancelablePromise<Array<RecentAdset>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/recent-adsets',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Logs
     * What this brand has published to Meta, newest first.
     * @param brandId
     * @param limit
     * @returns MetaAdLogRead Successful Response
     * @throws ApiError
     */
    public static getLogs(
        brandId: number,
        limit: number = 50,
    ): CancelablePromise<Array<MetaAdLogRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/ad-management/meta/logs',
            query: {
                'brand_id': brandId,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
